<div id="dashEntry" [class.plokk-mode]="showPlokkStats" [style.--primaryColor]="dashPrimaryColor">
    @if (showBanner) {
    <div class="banner-wrapper" [class.banner-info]="bannerType === 'info'"
        [attr.role]="bannerType === 'warning' ? 'alert' : 'status'"
        [attr.aria-live]="bannerType === 'warning' ? 'assertive' : 'polite'"
        tabindex="0"
        #bannerWrapper
        [attr.aria-label]="bannerText || 'Notice'">
        <mat-icon class="dashIcon">{{bannerType === 'info' ? 'info' : 'warning'}}</mat-icon>
        <div class="bannerMessage" #bannerMessage [style.font-size]="bannerFontSize">{{bannerText}}
        </div>
        @if (bannerCloseable) {
        <button class="banner-close" (click)="dismissBanner()" [attr.aria-label]="selText.close || 'Close'">
            <mat-icon>close</mat-icon>
        </button>
        }
    </div>
    }

    @if (showPlokkStats) {
    <div id="long-dash" class="wrapper">
        <div class="stat">{{(detailedStats?.trash?.stk?.total ?? "0") + " stk."}} & {{(detailedStats?.trash?.kg?.total
            ?? "0") + " kg"}} {{selText.totalTrashPicked}}<mat-icon class="dashIcon"> fastfood</mat-icon></div>
        <div class="stat">{{overViewStats['spatial']['km']}}{{selText.totalSpanPicked}} <mat-icon class="dashIcon">
                directions_walk</mat-icon></div>
        <div class="stat">{{detailedStats?.urls ?? ""}} {{selText.totalPhotos}}<mat-icon class="dashIcon">add_a_photo</mat-icon>
        </div>
        <div class="stat">{{overViewStats['activities']['reserved']}} {{selText.totalCoastsFostered}}<mat-icon
                class="dashIcon">waves</mat-icon></div>
    </div>

    <div id="short-dash" class="wrapper">
        <div class="stat">{{(detailedStats?.trash?.stk?.total ?? "0") + " stk."}} & {{(detailedStats?.trash?.kg?.total
            ?? "0") + " kg"}} {{selText.totalTrashPicked}} <mat-icon style="vertical-align: sub;"> fastfood</mat-icon>
        </div>
        <div class="stat">{{overViewStats['spatial']['km']}} <mat-icon class="dashIcon"> directions_walk</mat-icon>
        </div>
        <div class="stat">{{detailedStats?.urls ?? ""}} <mat-icon class="dashIcon">add_a_photo</mat-icon></div>
        <div class="stat">{{overViewStats['activities']['reserved']}} <mat-icon class="dashIcon">waves</mat-icon></div>
    </div>
    }
</div>